import { MedicalCategoryType, NonF2fMedicalCategoriesQuery } from '@/types/bff/gql-schema';
import { QueryClient } from '@tanstack/react-query';
import { EMedicalCategoryCategory, MedicalCategoryModel } from '../model/MedicalCategory';
import { useNonF2fMedicalCategoriesQuery } from './medicalCategory.gql.impl';

const parseMedicalCategoryType = (type: MedicalCategoryType): EMedicalCategoryCategory => {
  switch (type) {
    case MedicalCategoryType.Treatment:
      return EMedicalCategoryCategory.TREATMENT;
    case MedicalCategoryType.Department:
      return EMedicalCategoryCategory.DEPARTMENT;
    default:
      return EMedicalCategoryCategory.TREATMENT;
  }
};
const parseMedicalCategories = (data: NonF2fMedicalCategoriesQuery): MedicalCategoryModel[] => {
  return data.nonF2fMedicalCategories.map(
    (medicalCategory) =>
      new MedicalCategoryModel({
        _medicalCategory: {
          id: medicalCategory.id,
          category: parseMedicalCategoryType(medicalCategory.category),
          name: medicalCategory.name ?? '',
          iconUrl: medicalCategory.iconUrl ?? '',
        },
      })
  );
};
const DEFAULT_SIZE = 9;
const useNonF2fMedicalCategories = (size = DEFAULT_SIZE) => {
  const {
    data: medicalCategories,
    isLoading,
    error,
  } = useNonF2fMedicalCategoriesQuery(
    { size },
    {
      select: parseMedicalCategories,
    }
  );

  return {
    medicalCategories: medicalCategories ?? [],
    isLoading,
    error,
  };
};

export default useNonF2fMedicalCategories;

useNonF2fMedicalCategories.prefetchQuery = async (queryClient: QueryClient, size = DEFAULT_SIZE) => {
  await queryClient.prefetchQuery(
    useNonF2fMedicalCategoriesQuery.getKey({ size }),
    useNonF2fMedicalCategoriesQuery.fetcher({ size })
  );
};
